module.exports = __webpack_public_path__ + "static/media/ML intern.47a2f496.jpg";